import { render, staticRenderFns } from "./LogoText.vue?vue&type=template&id=761e40dc&scoped=true&"
import script from "./LogoText.vue?vue&type=script&lang=js&"
export * from "./LogoText.vue?vue&type=script&lang=js&"
import style0 from "./LogoText.vue?vue&type=style&index=0&id=761e40dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e40dc",
  null
  
)

export default component.exports